module.exports = __webpack_public_path__ + "static/media/bfile-kids.d4718819.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-kids.svg
// module id = 3083
// module chunks = 0